module.exports = "strong {\n  background: rgba(255, 166, 0, 0.685);\n  color: black;\n  padding: 15px;\n  border-radius: 5px; }\n"